import React, { useState } from "react";
import { useSpring, animated, easings } from "react-spring";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'
import "../componentsStyle.css"
import Regenerate from "../Regenerate/Regenerate";

const PdmChannels = (props) => {
  const { showMaximumChat, data, updateMessage, setIsFeedbackPop, loading, index, messages, sessionId, checkThumsDownFeedback } = props


  const fadeInProps = useSpring({
    from: { opacity: Math.random() },
    to: { opacity: 1 },
    config: { duration: 1000, easing: easings.easeInOut },
    // Adjust duration and easing as needed
  });

  const formatHeader = (header) => {
    return header.replace('NUMBER', 'No.').replace(/_/g, ' ');
  };

  const renderList = (data) => {
    const list = data?.llm_response[0]?.pdm_output;
    if (!list || list.length === 0) return null;
  
    const firstColumnWidth = showMaximumChat ? '35%' : '50%';
    const otherColumnWidth = showMaximumChat ? '20%' : '30%';
  
    const headers = Object.keys(list[0]).filter(header => header !== 'Seiebel_Name'); // Exclude 'Seiebel_Name'
  
    return (
      <div className="channel-list">
        <div style={{ borderRadius: '8px' }} className="list-of-channels">
          <table>
            <thead>
              <tr style={{ display: 'flex', marginBottom: '8px' }}>
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className="coloum-name"
                    style={{ width: index === 0 ? firstColumnWidth : otherColumnWidth }}
                  >
                    {formatHeader(header)} {/* Replace underscores with spaces for better readability */}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody style={{ gap: '8px', display: 'grid' }}>
              {list.map((channel, index) => (
                <React.Fragment key={index}>
                  <div style={{border: '1px solid #ddd' , borderRadius : '6px' , padding : '2px'}}>
                  <tr style={{ display: 'flex'  , marginBottom : '12px'}}>
                    {headers.map((header, index) => (
                      <td
                        key={index}
                        className="coloum-details"
                        style={{ width: index === 0 ? firstColumnWidth : otherColumnWidth }}
                      >
                        {channel[header]}
                      </td>
                    ))}
                  </tr>
                  {channel.Seiebel_Name && ( // Add a new row below the main row for 'Seiebel_Name'
                    <>
                      <div
                        colSpan={headers.length} // Span across all columns
                        className="coloum-details"
                        style={{
                          paddingTop: '8px',
                          fontStyle: 'italic',
                          color: '#555', // Optional styling
                          display : 'contents'
                        }}
                      >
                       <strong>Siebel Name : </strong> {channel.Seiebel_Name}
                      </div>
                    </>
                  )}
                  </div>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  


  return (
    <div className="server-text-response-body">

      {<>
        <div style={{ fontWeight: '600' }} className="channel-list-count"> Note: For any quarterly/annual packs, please check the subscriber eligibility in SIEBEL and use the SIEBEL Catalogue for the pack addition.</div>
        <div className="channel-list-reponse" style={{ color: '#220046' , marginTop: '14px'  }}>{data?.llm_response[0]?.Text}</div>
        {renderList(data)}
        {/* <Regenerate msg={data} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} index={index} messages={messages} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} /> */}
      </>}

      <div style={{ marginTop: '20px', marginLeft: '10px', display: 'grid' }}>
        <span className="sources-text">Sources</span>
        <span className="sources-text" style={{ fontWeight: '300' }}>For pack/channels related data, source won't be referenced</span>
      </div>
    </div>
  )
}

export default PdmChannels
